export default "#define GLSLIFY 1\nuniform vec3 uColor;\nuniform float uAlpha;\n\nvoid main () {\n  gl_FragColor = vec4(uColor, uAlpha);\n}";